import { createAsyncThunk } from "@reduxjs/toolkit";
import { driver_logout } from "../../../networking/urlEndPoints";

import Axios from "../../../networking/interceptor";
import Cookies from "js-cookie";
import {
	finalMissedRoute,
	todayMissedRoute,
	todayPendingRoute
} from "../../../storage";
import { persistor } from '../../../services/store/store'
import { clearAuthToken } from "../../../storage/authToken";
export const driverLogout = createAsyncThunk('driverLogout', async (_, { rejectWithValue }) => {
	try {

		const response = await Axios.post(driver_logout)
		const data = response.data
		clearAuthToken()
		localStorage.removeItem(todayPendingRoute)
		localStorage.removeItem(todayMissedRoute)
		localStorage.removeItem(finalMissedRoute)
		Cookies.remove('$8h-76l#^*')
		persistor.purge()
		window.location.href = '/'
		return data;

	} catch (error) {
		return rejectWithValue(error.response)
	}
});
